import { g as i } from "../../utils-BOfnFgIH.js";
import { I as e } from "../../constants-DeVuDy8J.js";
import { createElementBlock as a, openBlock as n, normalizeClass as d, createElementVNode as t } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const _ = {
  name: "DtIconZoho",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (l) => Object.keys(e).includes(l)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return e[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = i();
  }
}, r = ["aria-label", "data-qa", "aria-hidden"], u = /* @__PURE__ */ t("path", {
  d: "M22 10.473v4.742l-.656.64v-4.64l.656-.742Z",
  fill: "#E79225"
}, null, -1), h = /* @__PURE__ */ t("path", {
  d: "m17.7 10.477-.68.738.035.047 4.261-.016.04-.031.644-.742-4.3.004Z",
  fill: "#FFF16D"
}, null, -1), f = ["fill"], p = /* @__PURE__ */ t("path", {
  d: "M20.695 12.887a1.717 1.717 0 0 0-.383-.578 1.57 1.57 0 0 0-.543-.371 1.683 1.683 0 0 0-.648-.126c-.234 0-.453.043-.652.126a1.583 1.583 0 0 0-.543.37 1.706 1.706 0 0 0-.38.579 1.88 1.88 0 0 0-.124.707c0 .25.043.484.129.703.086.219.21.414.379.586.156.16.336.281.535.363.2.082.422.125.66.125a1.657 1.657 0 0 0 1.188-.488 1.772 1.772 0 0 0 .511-1.285c0-.262-.043-.496-.129-.711Zm-.894 1.531a.84.84 0 0 1-.68.3c-.289 0-.515-.1-.683-.3-.168-.2-.25-.477-.25-.828 0-.36.085-.637.25-.84.168-.203.39-.3.683-.3a.84.84 0 0 1 .68.3c.164.203.25.48.25.84 0 .351-.082.629-.25.828Z",
  fill: "#fff"
}, null, -1), m = /* @__PURE__ */ t("path", {
  d: "M16.594 10.086v.023l.554 4.262-.324.899-.043-.032-.57-4.086.012-.054.355-.989.016-.023Z",
  fill: "#009ADA"
}, null, -1), Z = /* @__PURE__ */ t("path", {
  d: "m12.324 10.68 4.27-.594-.36 1.023-.05.055-3.993.586.02-.73.113-.34Z",
  fill: "#91C9ED"
}, null, -1), D = ["fill"], I = /* @__PURE__ */ t("path", {
  d: "M15.52 11.906a.489.489 0 0 0-.133-.293.313.313 0 0 0-.211-.078.4.4 0 0 0-.067.004.324.324 0 0 0-.242.149.388.388 0 0 0-.055.218.95.95 0 0 0 .008.102l.153 1.082-1.211.18-.153-1.082a.489.489 0 0 0-.132-.29.296.296 0 0 0-.207-.082c-.02 0-.04 0-.06.004a.347.347 0 0 0-.253.149.388.388 0 0 0-.055.219c0 .03.004.066.008.105l.414 2.816c.02.13.063.227.14.293.06.051.13.075.216.075.023 0 .047 0 .07-.004a.316.316 0 0 0 .234-.149.403.403 0 0 0 .051-.21.93.93 0 0 0-.008-.102l-.168-1.114 1.211-.18.168 1.114c.02.129.063.227.137.29.059.05.129.077.21.077.02 0 .044 0 .067-.004a.324.324 0 0 0 .243-.148.407.407 0 0 0 .054-.215.962.962 0 0 0-.008-.102l-.421-2.824Z",
  fill: "#fff"
}, null, -1), g = /* @__PURE__ */ t("path", {
  d: "m8.328 9-1.52 3.61.208 1.585.011-.004 1.707-3.84-.007-.082-.368-1.218L8.33 9Z",
  fill: "#66BF6B"
}, null, -1), v = /* @__PURE__ */ t("path", {
  d: "m8.328 9 .395 1.324.007.028 3.758 1.683.012-.008-.32-1.265L8.328 9Z",
  fill: "#98D0A0"
}, null, -1), q = ["fill"], y = /* @__PURE__ */ t("path", {
  d: "M11.355 12.34a1.639 1.639 0 0 0-.343-.563 1.602 1.602 0 0 0-.54-.37 1.606 1.606 0 0 0-.636-.134h-.012c-.219 0-.433.051-.644.145a1.72 1.72 0 0 0-.578.406 2.04 2.04 0 0 0-.399.625c-.101.239-.156.48-.168.719v.082c0 .21.035.418.11.621a1.555 1.555 0 0 0 .89.925c.207.09.418.134.633.134h.004c.215 0 .43-.047.64-.137a1.75 1.75 0 0 0 .583-.41c.164-.172.3-.38.402-.621.101-.242.156-.48.168-.719v-.07a1.69 1.69 0 0 0-.11-.633Zm-.753 1.125c-.141.336-.332.566-.563.691a.814.814 0 0 1-.383.102.929.929 0 0 1-.355-.078c-.266-.114-.43-.293-.5-.551a1.02 1.02 0 0 1-.035-.27c0-.187.047-.394.14-.617.145-.344.336-.578.567-.707a.77.77 0 0 1 .382-.101c.118 0 .235.027.36.078.262.113.426.293.496.55a.971.971 0 0 1 .035.266c0 .195-.047.406-.144.637Z",
  fill: "#fff"
}, null, -1), S = /* @__PURE__ */ t("path", {
  d: "m6.508 9.613.617 4.133-.281 1.453-.04-.05-.6-3.993v-.078l.265-1.394.039-.07Z",
  fill: "#760D16"
}, null, -1), $ = /* @__PURE__ */ t("path", {
  d: "m2 11.75.293-1.46 4.215-.677-.285 1.489v.097l-4.172.59L2 11.75Z",
  fill: "#EF463E"
}, null, -1), b = ["fill"], E = /* @__PURE__ */ t("path", {
  d: "M5.773 14.547a.292.292 0 0 0-.132-.086.609.609 0 0 0-.204-.027c-.074 0-.16.007-.253.023l-1.102.188a1.05 1.05 0 0 1 .129-.332c.082-.153.207-.336.367-.547.055-.075.098-.13.129-.168.02-.028.05-.063.09-.114.254-.332.406-.601.469-.812.035-.121.054-.242.062-.363.004-.036.004-.067.004-.098a1.5 1.5 0 0 0-.023-.258.583.583 0 0 0-.059-.191.283.283 0 0 0-.098-.114.369.369 0 0 0-.191-.039c-.066 0-.149.008-.246.024l-1.274.219c-.152.027-.27.07-.34.14a.269.269 0 0 0-.085.203.4.4 0 0 0 .004.067c.02.11.074.187.164.226a.486.486 0 0 0 .195.035.91.91 0 0 0 .172-.015l1.062-.188c0 .02.004.04.004.055a.557.557 0 0 1-.035.195c-.031.09-.11.215-.238.375-.035.043-.09.114-.164.203-.29.348-.492.645-.617.891-.09.172-.149.336-.184.504-.02.098-.031.188-.031.277 0 .063.004.125.015.184a.799.799 0 0 0 .063.21.278.278 0 0 0 .11.122.395.395 0 0 0 .187.031c.105 0 .25-.015.433-.047l1.157-.199c.203-.035.347-.086.43-.152a.27.27 0 0 0 .1-.215.431.431 0 0 0-.007-.07.259.259 0 0 0-.063-.137Z",
  fill: "#fff"
}, null, -1), F = ["id"], U = /* @__PURE__ */ t("stop", {
  offset: ".006",
  "stop-color": "#FFE513"
}, null, -1), A = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-color": "#FDB924"
}, null, -1), M = [
  U,
  A
], B = ["id"], L = /* @__PURE__ */ t("stop", {
  offset: ".006",
  "stop-color": "#008CD2"
}, null, -1), O = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-color": "#00649D"
}, null, -1), z = [
  L,
  O
], C = ["id"], w = /* @__PURE__ */ t("stop", { "stop-color": "#26A146" }, null, -1), x = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-color": "#008A52"
}, null, -1), G = [
  w,
  x
], k = ["id"], H = /* @__PURE__ */ t("stop", { "stop-color": "#D92231" }, null, -1), N = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-color": "#BA2234"
}, null, -1), Q = [
  H,
  N
];
function j(l, R, s, V, J, o) {
  return n(), a("svg", {
    "aria-label": s.ariaLabel,
    class: d([o.iconSizeClass, "d-icon d-icon--zoho"]),
    "data-qa": o.dataQA,
    "aria-hidden": o.ariaHidden,
    role: "img",
    "data-name": "Zoho",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    u,
    h,
    t("path", {
      d: "M17.02 11.215h4.335v4.644H17.02v-4.644Z",
      fill: `url(#${l.uniqueID}a)`
    }, null, 8, f),
    p,
    m,
    Z,
    t("path", {
      d: "m16.234 11.11.59 4.16-4.207.59-.566-4.02.246-.192 3.937-.539Z",
      fill: `url(#${l.uniqueID}b)`
    }, null, 8, D),
    I,
    g,
    v,
    t("path", {
      d: "m8.723 10.324 3.777 1.703-1.707 3.871-3.777-1.703 1.707-3.87Z",
      fill: `url(#${l.uniqueID}c)`
    }, null, 8, q),
    y,
    S,
    $,
    t("path", {
      d: "m6.223 11.102.62 4.097-4.171.653L2 11.75l4.223-.648Z",
      fill: `url(#${l.uniqueID}d)`
    }, null, 8, b),
    E,
    t("defs", null, [
      t("linearGradient", {
        id: `${l.uniqueID}a`,
        x1: "19.187",
        y1: "11.281",
        x2: "19.187",
        y2: "15.719",
        gradientUnits: "userSpaceOnUse"
      }, M, 8, F),
      t("linearGradient", {
        id: `${l.uniqueID}b`,
        x1: "12.266",
        y1: "11.75",
        x2: "16.601",
        y2: "15.266",
        gradientUnits: "userSpaceOnUse"
      }, z, 8, B),
      t("linearGradient", {
        id: `${l.uniqueID}c`,
        x1: "9.758",
        y1: "11.873",
        x2: "9.758",
        y2: "15.761",
        gradientUnits: "userSpaceOnUse"
      }, G, 8, C),
      t("linearGradient", {
        id: `${l.uniqueID}d`,
        x1: "4.118",
        y1: "11.491",
        x2: "4.762",
        y2: "15.532",
        gradientUnits: "userSpaceOnUse"
      }, Q, 8, k)
    ])
  ], 10, r);
}
const X = /* @__PURE__ */ c(_, [["render", j]]);
export {
  X as default
};
//# sourceMappingURL=zoho.js.map
